import React from 'react';
import Dialog from '@mui/material/Dialog';
import InputAdornment from '@mui/material/InputAdornment';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import Button from '@mui/material/Button';
import { Box, Stack, Typography } from '@mui/material';
import { excludingFilters } from '../../../helpers';
import FilterRow from '../../users/list/table/filters/FilterRow';
import { CalendarSVG, FilterSVG } from '../../../components';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../styles/theme';

export default function ClientsFiltersModal ({
    show,
    open,
    onHide,
    onClose,
    date,
    setDate,
    filtersList,
    handleAddFilter,
    handleRemoveFilter,
    handleFilterInputChange,
    typesToFilter,
    handleSearch,
    propertiesToFilter,
    initialLabel,
    handleCleanFilters,
    height,
    width,
    bottomTop,
    marginTopProps,
    getTranslatedFilter
}) {
    const isVisible = show ?? open;
    const handleClose = onHide ?? onClose;
    const [dateFrom, dateTo] = date;
    const { t } = useTranslation();

    const handleDateFromChange = (newStartDate) => {
        setDate([newStartDate, date[1]]);
    };

    const handleDateToChange = (newEndDate) => {
        setDate([date[0], newEndDate]);
    };

    const handleCancelChanges = () => {
        handleClose && handleClose();
    };

    return (
        <Dialog
            open={isVisible}
            onClose={() => handleCancelChanges()}
            PaperProps={{ style: { width: width || '360px', height: height || 'fit-content', borderRadius: '12px' }, className: 'modal_clientsFilters' }}
        >
            <DialogTitle>
                <Box display='flex'>
                    <FilterSVG customStroke={palette.secondary[600]}/>
                    <Typography sx={{ marginLeft: '6px', marginTop: '3px' }} variant='pageTitle'>
                        {t('filter.modal.title')}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box>
                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                        <Stack direction={'row'} style={{ marginTop: '10px' }} gap={'16px'}>
                            <Stack alignItems='flex-start' gap={'4px'} style={{ width: '190px' }} >
                                <Typography variant='subtitle2' lineHeight={'20px'} >{t('filter.modal.date.from')}</Typography>

                                <MobileDatePicker
                                    inputProps={{ size: 'small' }}
                                    disableToolbar
                                    margin='normal'
                                    id='date-picker-dialog-from'
                                    format='dd/MM/yyyy'
                                    value={dateFrom || null}
                                    onChange={handleDateFromChange}
                                    slotProps={{
                                        textField: {
                                            color: 'primary',
                                            InputProps: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <CalendarSVG />
                                                    </InputAdornment>
                                                ),
                                            },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: '35px',
                                            backgroundColor: 'white',

                                        },
                                        '& .MuiInputLabel-root': {
                                            lineHeight: '10px'
                                        },
                                    }}
                                />
                            </Stack>
                            <Stack alignItems='flex-start' gap={'4px'} style={{ width: '190px' }} >
                                <Typography variant='subtitle2' lineHeight={'20px'} >{t('filter.modal.date.to')}</Typography>

                                <MobileDatePicker
                                    disableToolbar
                                    margin='normal'
                                    id='date-picker-dialog-to'
                                    format='dd/MM/yyyy'
                                    value={dateTo || null}
                                    onChange={handleDateToChange}
                                    slotProps={{
                                        textField: {
                                            color: 'secondary',
                                            InputProps: {
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <CalendarSVG />
                                                    </InputAdornment>
                                                ),
                                            },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            height: '35px',
                                            backgroundColor: 'white',
                                        },
                                        '& .MuiInputLabel-root': {
                                            lineHeight: '10px'
                                        },
                                    }}
                                />
                            </Stack>
                        </Stack>
                    </LocalizationProvider>
                </Box>
                <Box >
                    {filtersList.length &&
            propertiesToFilter.map((filter) => {
                return (
                    <FilterRow
                        filter={getTranslatedFilter ? getTranslatedFilter(filter) : filter}
                        filtersList={filtersList}
                        selectFilter={filtersList.find(item => item.property.description === filter.value.description)}
                        handleRemoveFilter={handleRemoveFilter}
                        handleAddFilter={handleAddFilter}
                        handleFilterInput={handleFilterInputChange}
                        key={filter.id}
                        typesToFilter={excludingFilters(typesToFilter, filtersList)}
                        propertiesToFilter={propertiesToFilter}
                        marginTopProps={marginTopProps}
                    />
                );
            })}
                </Box>
                <Box style={{ display: 'flex', justifyContent: 'flex-end', marginTop: bottomTop || '40px' }}>
                    <Button
                        style={{
                            textTransform: 'none',
                            width: '110px',
                            fontSize: '14px',
                            color: filtersList[0].property.description || (dateFrom && dateTo) ? palette.secondary[600] : palette.disabled.main,
                        }}
                        onClick={handleCleanFilters}
                    >
                        {t('filter.modal.delete')}
                    </Button>
                    <Button
                        onClick={handleSearch}
                        disabled={!((dateFrom && dateTo) || filtersList[0].property.description)}
                        style={{
                            textTransform: 'none',
                            width: '127px',
                            fontSize: '14px',
                            borderRadius: '50px',
                            backgroundColor: filtersList[0].property.description || (dateFrom && dateTo) ? palette.primary.main : palette.disabled[500],
                            color: 'white',
                            padding: '11px 16px'
                        }}
                    >
                        {t('filter.modal.apply')}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
